export const backendBaseUrl = "https://connect.eqarcom.ae";
